import { UI_CONTAINER_TYPE } from 'app/constants/AnalyticsGa4Constants';

// TODO: LIST should no longer be used in the configuration.
// LIST_HERO replaces it.
// We want to remove the DEPRECATED_LIST_BROWSE_ROW_TYPE and all references
// once all configs have been updated to use LIST_HERO.
export const DEPRECATED_LIST_ELEMENT_CONFIG_TYPE = 'LIST';

export const BROWSE_CONFIG_ELEMENT_TYPE = {
  BIB: 'BIB',
  LINK: 'LINK',
  LIST_BIB: 'LIST_BIB',
  LIST_CARD: 'LIST_CARD',
  LIST_HERO: 'LIST_HERO',
  NAV: 'NAV'
};

export const ROW_CHILD_COMPONENT_TYPE = {
  BIBS: 'display-bibs',
  LISTS: 'lists',
  LISTS_HERO: 'lists-hero',
  LINKS: 'links',
  NAV: 'nav'
};

export const UI_CONTAINER_TYPE_BY_BROWSE_CONFIG_ELEMENT_TYPE = {
  [BROWSE_CONFIG_ELEMENT_TYPE.BIB]: UI_CONTAINER_TYPE.BROWSE_ROW_BIB,
  [BROWSE_CONFIG_ELEMENT_TYPE.LINK]: UI_CONTAINER_TYPE.BROWSE_ROW_LINK,
  [BROWSE_CONFIG_ELEMENT_TYPE.LIST_BIB]: UI_CONTAINER_TYPE.BROWSE_ROW_LIST_BIB,
  [BROWSE_CONFIG_ELEMENT_TYPE.LIST_CARD]: UI_CONTAINER_TYPE.BROWSE_ROW_LIST_CARD,
  [BROWSE_CONFIG_ELEMENT_TYPE.LIST_HERO]: UI_CONTAINER_TYPE.BROWSE_ROW_LIST_HERO,
  [BROWSE_CONFIG_ELEMENT_TYPE.NAV]: UI_CONTAINER_TYPE.BROWSE_ROW_NAV
};
